import { Route } from '@angular/router';

export const LinesRoute: Route = {
  path: 'lines',
  loadComponent() {
    return import('@daas-consulting/production/shared/frontend/pages').then(
      (c) => c.LayoutBase2PageComponent
    );
  },
  loadChildren() {
    return import(
      '@daas-consulting/production/shared/frontend/lines_shell'
    ).then((c) => c.linesShellRoutes);
  },
};
